import { apiRequest } from "./common";

const createAcademic = async (data) => {
    const response = await apiRequest('post', '/academic-info', data);
    return response.data;
};

const updateAcademic = async (id, data) => {
    const response = await apiRequest('put', `/academic-info/${id}`, data);
    return response.data;
};

const getAcademicInfo = async (studentId, currentGrade) => {
    const response = await apiRequest('get', `/academic-info/by-student/${studentId}?${currentGrade ? `studentGrade=${currentGrade}`: ''}`);
    return response.data;
};

const createSubject = async (data) => {
    const response = await apiRequest('post', '/academic-subject', data);
    return response.data;
};

const getSubjectInfo = async (academicId) => {
    const response = await apiRequest('get', `/academic-subject/by-academic/${academicId}`);
    return response.data;
};

const updateSubject = async (id, data) => {
    const response = await apiRequest('put', `/academic-subject/${id}`, data);
    return response.data;
};

const deleteSubject = async (id) => {
    const response = await apiRequest('delete', `/academic-subject/${id}`);
    return response.data;
};

export {
    createAcademic,
    getAcademicInfo,
    createSubject,
    updateAcademic,
    updateSubject,
    getSubjectInfo,
    deleteSubject
}